<template>
  <div class="km__modules__senddraft km__popup">
    <button class="km__button--back" type="button" name="back" @click="$emit('close')" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="$emit('close')" aria-label="close"></button>
    <header class="km__popup--heading">
      <h2>{{ $t("konf_sendDraftToFriend_header") }}</h2>
    </header>
    <div class="km__popup--content">
      <p>{{ $t("konf_konf_sendDraftToFriend_explanation") }}</p>
      <ul class="km__list--modules">
        <li class="km__list__element--modules">
          <label class="km__label--text" for="sendDraft_ownName">{{ $t("konf_sendDraft_ownNameLabel") }}</label>
        </li>
        <li class="km__list__element--modules">
          <input class="km__input--standard" type="text" v-model="ownName">
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text" for="sendDraft_ownEmail">{{ $t("Ihre_Email") }}</label>
        </li>
        <li class="km__list__element--modules">
          <input class="km__input--standard" type="text" v-model="ownEmail" :class="{error:ownEmailWrong}">
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text" for="sendDraft_friendsEmail">{{ $t("Label_Emailfreund") }}</label>
        </li>
        <li class="km__list__element--modules">
          <input class="km__input--standard" type="text" v-model="friendEmail" :class="{error:friendEmailWrong}">
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text" for="sendDraft_messageToFriend">{{ $t("Nachricht") }}</label>
        </li>
        <li class="km__list__element--modules">
          <textarea class="km__input--standard area" v-model="message"></textarea>
        </li>
      </ul>
    </div>
    <div class="km__popup--buttons">
      <button class="km__button--standard" @click="$emit('close')">{{ $t("konf_Cancel") }}</button>
      <button class="km__button--standard" @click="send">{{ $t("konf_senden") }}</button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref} from "vue";
import {checkEmail} from "@k/global/globalUtils";

const emit = defineEmits(["shareByEmail", "close"]);

const ownName = ref("");
const ownEmail = ref("");
const friendEmail = ref("");
const message = ref("");
const ownEmailWrong = ref(false);
const friendEmailWrong = ref(false);
const validate = () => {
  return new Promise((resolve, reject) => {
        const data = {
          benutzername: ownName.value.trim(),
          ihreemail: ownEmail.value.trim(),
          email: friendEmail.value.trim(),
          nachricht: message.value.trim(),
        };
        ownEmailWrong.value = !checkEmail(ownEmail.value);
        friendEmailWrong.value = !checkEmail(friendEmail.value);
        if (ownEmailWrong.value || friendEmailWrong.value) {
          reject();
        }
        resolve(data);
      }
  );
}

const send = () => validate().then(data => emit("shareByEmail", data));

</script>

<style scoped lang="scss">
.km__modules__senddraft {
  .km__list--modules {
    li {
      margin-bottom: 5px;
    }
  }
}

.km__input--standard {
  margin-bottom: 15px;

  &.area {
    height: 70px;
  }
}

.error {
  color: red;
  border: 1px solid red;
}
</style>
